var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckcrFr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99967 2.66665C5.05416 2.66665 2.66634 5.05446 2.66634 7.99998C2.66634 10.9455 5.05416 13.3333 7.99967 13.3333C10.9452 13.3333 13.333 10.9455 13.333 7.99998C13.333 5.05446 10.9452 2.66665 7.99967 2.66665ZM1.33301 7.99998C1.33301 4.31808 4.31778 1.33331 7.99967 1.33331C11.6816 1.33331 14.6663 4.31808 14.6663 7.99998C14.6663 11.6819 11.6816 14.6666 7.99967 14.6666C4.31778 14.6666 1.33301 11.6819 1.33301 7.99998Z",
    fill: "#FF865C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4951 8.10455C11.4951 8.47274 11.1966 8.77122 10.8284 8.77122L7.72386 8.77122C7.35567 8.77122 7.05719 8.47274 7.05719 8.10455L7.05719 5.55226C7.05719 5.18407 7.35567 4.8856 7.72386 4.8856C8.09205 4.8856 8.39052 5.18407 8.39052 5.55226L8.39052 7.43788L10.8284 7.43788C11.1966 7.43788 11.4951 7.73636 11.4951 8.10455Z",
    fill: "#FF865C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckcrFr);
export default __webpack_public_path__ + "static/media/Check cr-fr.a8992c2cc0a838a83923151500221d9d.svg";
export { ForwardRef as ReactComponent };